<script>
import TempTasksRow from './TempTasksRow';

export default {
  name: 'TempTasksRow',
  props: ['item', 'rowindent', 'depth', 'maxdepth', 'last'],
  components: { TempTasksRow },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    checkSubTasks(task, result = 0) {
      for(var i in task.tasks) {
        result = result + 1;
        result = this.checkSubTasks(task.tasks[i], result);
      }
      return result;
    },
    openSubTask(value) {
      this.$emit('open', value)
    },
    createSubTask(id) {
      this.$emit('create', id)
    }
  }
}
</script>

<template>
  <div style="display: contents">

    <tr>
      <td class="p-0 bg-gray-100">
        <div class="bg-white" :style="'margin-left:'+(rowindent * depth)+'px;'">
          <div v-if="(depth + 1) < maxdepth" class="d-inline-block align-middle text-gray-500 p-2" :class="(depth > 0 ? 'border-left border-light' : '')" @click="$emit('create', item.id)">
            <button type="button" class="btn btn-sm btn-success "><Icon icon="ri:arrow-right-down-line"></Icon></button>
          </div>
          <div class="d-inline-block align-middle border-left border-light h-100 w-100 p-1 pl-2 bg-hover-gray-200 _c-pointer" @click="$emit('open', item)">
            <div class="text-dark font-weight-bold">{{item.title}}</div>
            <div class="small text-muted text-truncate _w-m-500">{{item.summary}}</div>
          </div>
        </div>
      </td>
      <td class="p-1 _c-pointer" @click="$emit('open', item)">
        <div class="alert small m-0 text-white" :class="'bg-'+(item.status == 0 ? 'danger' : item.status == 1 ? 'purple' : item.status == 2 ? 'warning' : item.status == 3 ? 'blue' : item.status == 4 ? 'success' : 'dark')">{{ (item.status == 0 ? 'Trash' : item.status == 1 ? 'Draft' : item.status == 2 ? 'Active' : item.status == 3 ? 'Hold' : item.status == 4 ? 'Complete' : '') }}</div>
      </td>
      <td class="p-1 _c-pointer" @click="$emit('open', item)">
        <div class="alert small m-0" :class="'alert-'+(item.priority == 1 ? 'teal' : item.priority == 2 ? 'light' : item.priority == 3 ? 'danger' : 'dark')">{{ (item.priority == 1 ? 'Low' : item.priority == 2 ? 'Normal' : item.priority == 3 ? 'High' : '') }}</div>
      </td>
      <td class="py-1 _c-pointer" @click="$emit('open', item)">{{checkSubTasks(item)}}</td>
      <td class="py-1 _c-pointer" @click="$emit('open', item)">
        <div v-for="(assign, assign_i) in item.assigned_to" :key="assign_i" class="d-inline-block _w-40 mr-2 align-top" v-tippy :content="`<div class='col p-0 small'><h6 class='mb-0'>`+assign.name+`</h6><div class='text-muted small _lh-16'>`+assign.email+`</div><div class='text-muted small _lh-16'>`+formatPhone(assign.phone)+`</div></div>`">
          <img v-if="assign.avatar" :src="formatImage(assign.avatar)" class="_w-40 rounded">
          <avatar v-else :username="assign.name" :size="40" :rounded="false" class="rounded"></avatar>
        </div>
      </td>
      <td v-tippy :content="item.start_date ? moment(item.start_date).fromNow() : '' " class="_c-pointer" @click="$emit('open', item)">{{ item.start_date ? moment(item.start_date).format('MM-DD-YYYY') : '' }}</td>
      <td v-tippy :content="item.due_date ? moment(item.due_date).fromNow() : '' " class="_c-pointer" @click="$emit('open', item)">{{ item.due_date ? moment(item.due_date).format('MM-DD-YYYY') : '' }}</td>
      <td v-tippy :content="item.completed_date ? moment(item.completed_date).fromNow() : '' " class="_c-pointer" @click="$emit('open', item)">{{ item.completed_date ? moment(item.completed_date).format('MM-DD-YYYY') : '' }}</td>
      <td v-tippy :content="item.created_at ? moment(item.created_at).fromNow() : '' " class="_c-pointer" @click="$emit('open', item)">{{ item.created_at ? moment(item.created_at).format('MM-DD-YYYY') : '' }}</td>
    </tr>

    <TempTasksRow
      v-for="(task, task_i) in item.tasks"
      :key="task_i"
      :item="task"
      :rowindent="rowindent"
      :depth="depth + 1"
      :maxdepth="maxdepth"
      :last="item.tasks.length == (task_i + 1) ? true : false"
      @open="openSubTask"
      @create="createSubTask"
    ></TempTasksRow>


  </div>
</template>
